import React, { FC } from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

type LimitationsSkeletonProps = {
  dataTestId?: string;
};

const LimitationsSkeleton: FC<LimitationsSkeletonProps> = ({ dataTestId }) => {
  return (
    <Box p={3} data-test-id={dataTestId}>
      <Skeleton variant="text" width={150} height={30} sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
        <Grid item xs={6}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
        <Grid item xs={6}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
        <Grid item xs={6}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rectangular" width="100%" height={40} />
        </Grid>
      </Grid>
      <Box mt={3} display="flex" justifyContent="flex-end">
        <Skeleton variant="rectangular" width={80} height={40} />
      </Box>
      <Skeleton variant="text" width={300} height={20} sx={{ mt: 2 }} />
    </Box>
  );
};

export default LimitationsSkeleton;
